import kebabCasify from 'lib/string/kebabCasify'

export type ResponsiveClassNameGetter<Value extends string | number> = (
  /**
   * for mobile and higher
   *
   * _ideally kebab-based_
   */
  value: Value | undefined,
  /**
   * for tablet and higher
   *
   * _ideally kebab-based_
   */
  tabletValue?: Value,
  /**
   * for desktop and higher
   *
   * _ideally kebab-based_
   */
  desktopValue?: Value,
) => [
  className: string | undefined,
  tabletClassName: string | undefined,
  desktopClassName: string | undefined,
]

function createResponsiveClassNameGetter<Value extends string | number>(
  /**
   * The base string to be used for generated class names.
   *
   * _will be kebab-cased_
   */
  base: string,
): ResponsiveClassNameGetter<Value> {
  const kebabCaseBase = kebabCasify(base)

  return (
    value,
    tabletValue,
    desktopValue,
  ) => {
    return [
      value !== undefined ? `${kebabCaseBase}-${value}` : undefined,
      tabletValue !== undefined ? `tablet-${kebabCaseBase}-${tabletValue}` : undefined,
      desktopValue !== undefined ? `desktop-${kebabCaseBase}-${desktopValue}` : undefined,
    ]
  }
}

export default createResponsiveClassNameGetter
